
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/[group]/[slug]",
      function () {
        return require("private-next-pages/docs/[group]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/[group]/[slug]"])
      });
    }
  